import Dbm from "dbm";
import Website from "../../../index.js";

export default class Player extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.isGrounded = true;

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        this.item.setValue("layers", []);
        this.item.setValue("jumpLayers", []);
        this.item.setValue("projectileLayers", []);

        this.item.setValue("invincible", false);
        this.item.setValue("isGrounded", true);
        this.item.setValue("jumpHeld", false);
        this.item.setValue("numberOfItems", 6);
        this.item.setValue("legsMode", "walk");

        this.item.requireProperty("isThrowing", false).addUpdate(this._getScopedCallFunctionCommand(this._updateThrowGraphics));
        
        let mainBody = Matter.Bodies.rectangle(0, 0, Website.game.Sizes.CHARACTER_WIDTH, Website.game.Sizes.CHARACTER_HEIGHT, {
            label: "player",
            friction: 0.01,
            frictionAir: 0.02,
            restitution: 0,
            inertia: Infinity,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.PLAYER, Website.game.PhysicsGroups.PLAYER_INTERACTIONS)
        });

        let playerDamage = Matter.Bodies.rectangle(0, 0, 0.3*Website.game.Sizes.CHARACTER_WIDTH, 0.8*Website.game.Sizes.CHARACTER_HEIGHT, {
            label: "player-damage",
            isSensor: true,
            density: 0.001,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.PLAYER_DAMAGE, Website.game.PhysicsGroups.PLAYER_DAMAGE_INTERACTIONS)
        });

        let playerBody = Matter.Body.create({
            parts: [mainBody, playerDamage],
            label: "player-compound",
            mass: mainBody.mass,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.PLAYER | Website.game.PhysicsGroups.PLAYER_DAMAGE, Website.game.PhysicsGroups.PLAYER_INTERACTIONS | Website.game.PhysicsGroups.PLAYER_DAMAGE_INTERACTIONS)
        });

        this.item.setValue("physicsBody", playerBody);

        let speechBubble = new Website.game.gameplay.player.SpeechBubble();
        speechBubble.item.pixiLayer.position.set(15, -60);
        this.item.setValue("speechBubble", speechBubble.item);
    }

    addLayer(aLayer) {
        this.item.addToArray("layers", aLayer);
        this.item.pixiLayer.addChild(aLayer.pixiLayer);
    }

    addJumpLayer(aLayer) {
        this.item.addToArray("jumpLayers", aLayer);
        this.addLayer(aLayer);
    }

    addProjectileLayer(aLayer) {
        this.item.addToArray("projectileLayers", aLayer);
        this.addLayer(aLayer);
    }

    addLayers(aTextures) {

        let currentArray = aTextures;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let layer = new Dbm.repository.Item();

            let currentTexture = currentArray[i];
            let sprite = new PIXI.Sprite(currentTexture);
            sprite.anchor.set(0.5, 1);

            layer.setValue("pixiLayer", sprite);
            this.addLayer(layer);
        }
    }

    setWalkAnimation(aSprite) {
        this.item.pixiLayer.addChild(aSprite);

        let layer = new Dbm.repository.Item();
        layer.setValue("pixiLayer", aSprite);
        this.addLayer(layer);

        return this;
    }

    setPosition(aX, aY) {
        Matter.Body.setPosition(this.item.physicsBody, {
            x: aX,
            y: aY
        });

        this.item.pixiLayer.x = aX;
        this.item.pixiLayer.y = Math.round(aY+0.5*Website.game.Sizes.CHARACTER_HEIGHT)+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION);
    }

    startJump() {
        //console.log("startJump");
        if(this.item.isGrounded) {
            this.item.jumpHeld = true;
            
            this.jumpTime = 0;

            Matter.Body.setVelocity(this.item.physicsBody, {
                x: this.item.physicsBody.velocity.x,
                y: -3
            });
            
            this.item.isGrounded = true;

            {
                let currentArray = this.item.jumpLayers;
                let currentArrayLength = currentArray.length;
                for(let i = 0; i < currentArrayLength; i++) {
                    let currentLayer = currentArray[i];

                    currentLayer.controller.showGraphics("jump");
                }
            }

            let sound = Website.game.getTextures("sounds/game", "jump2")[0];
            sound.play({loop: false, volume: 0.3});
        }
    }

    startWalk() {
        this.item.legsMode = "walk";

        let currentArray = this.item.jumpLayers;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentLayer = currentArray[i];

            currentLayer.controller.showGraphics(this.item.legsMode);
        }
    }

    stand() {
        this.item.legsMode = "stand";

        let currentArray = this.item.jumpLayers;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentLayer = currentArray[i];

            currentLayer.controller.showGraphics(this.item.legsMode);
        }
    }

    jumpReleased() {
        //console.log("jumpReleased");
        this.item.jumpHeld = false;
    }

    throw() {
        //console.log("throw");

        if(this.item.isThrowing) {
            return;
        }

        let projectile = this.item.gamePlay.controller.createProjectile(
            this.item.physicsBody.position.x+0.8*0.5*Website.game.Sizes.CHARACTER_WIDTH,
            this.item.physicsBody.position.y - 0.1*Website.game.Sizes.CHARACTER_HEIGHT,
        );

        let THROW_SPEED_X = 5;
        let THROW_SPEED_Y = -3;

        if(this.item.isGrounded) {
            Matter.Body.setVelocity(projectile.body, {
                x: THROW_SPEED_X,
                y: THROW_SPEED_Y
            });
        }
        else {
            Matter.Body.setVelocity(projectile.body, {
                x: 3,
                y: 2
            });
        }

        this.item.isThrowing = true;
        this.item.properties.isThrowing.delayValue(false, 0.4);
    }

    _updateThrowGraphics() {
        let graphicsName = this.item.isThrowing ? "empty" : "loaded";
        {
            let currentArray = this.item.projectileLayers;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentLayer = currentArray[i];

                currentLayer.controller.showGraphics(graphicsName);
            }
        }
    }

    jumpEnded() {
        {
            let currentArray = this.item.jumpLayers;
            let currentArrayLength = currentArray.length;
            for(let i = 0; i < currentArrayLength; i++) {
                let currentLayer = currentArray[i];

                currentLayer.controller.showGraphics(this.item.legsMode);
            }
        }
    }

    updateControl(aTime, aDelta) {
        let maxJumpTime = 60;
        if (this.item.jumpHeld && this.jumpTime < maxJumpTime) {

            let parameter = (this.jumpTime/maxJumpTime)/(maxJumpTime-1);
            let force = Math.pow(1-parameter, 1)*0.005;

            Matter.Body.applyForce(this.item.physicsBody, this.item.physicsBody.position, {
                x: 0,
                y: -1*force
            });

            this.jumpTime++;
        }
    }

    setScreenX(aX) {
        Matter.Body.setPosition(this.item.physicsBody, {
            x: aX,
            y: this.item.physicsBody.position.y
        });
    }

    updatePositionFromPhysics() {
        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = Math.round(this.item.physicsBody.position.y+0.5*Website.game.Sizes.CHARACTER_HEIGHT)+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION);
    }

    update(aTime, aDelta) {

        
        let layers = this.item.layers;

        if(this.item.invincible) {
            let value = 0.5*(Math.sin(4*aTime*2*Math.PI)+1);
            this.item.pixiLayer.alpha = 1-Math.pow(value, 2);
        }
        else {
            this.item.pixiLayer.alpha = 1;
        }

        let rotationSpeed = 0.8;

        let multiplier = 1;
        if(this.item.legsMode === "stand") {
            multiplier = 0;
        }

        if(layers.length) {
            let playerId = Dbm.getRepositoryItem("game").playerId;
            if(playerId === "affe") {

                layers[1].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[1].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[3].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[3].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[4].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[4].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[5].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[5].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[6].pixiLayer.x = multiplier*0.4*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
                layers[6].pixiLayer.y = multiplier*0.2*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
            }
            else if(playerId === "svenne") {
                layers[3].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[3].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[4].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[4].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[5].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[5].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[6].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[6].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[7].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[7].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[8].pixiLayer.x = multiplier*0.4*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
                layers[8].pixiLayer.y = multiplier*0.2*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);

                layers[9].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[9].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
            }
            else if(playerId === "saga") {
                layers[1].pixiLayer.x = multiplier*0.4*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
                layers[1].pixiLayer.y = multiplier*0.2*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);

                layers[2].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[2].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[4].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[4].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[5].pixiLayer.x = multiplier*0.5*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[5].pixiLayer.y = multiplier*0.5*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[6].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[6].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[7].pixiLayer.x = multiplier*0.4*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
                layers[7].pixiLayer.y = multiplier*0.2*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
            }
            else if(playerId === "ninni") {

                layers[1].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[1].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[4].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[4].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[5].pixiLayer.x = multiplier*0.4*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
                layers[5].pixiLayer.y = multiplier*0.2*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
            }
            else {
                layers[1].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);
                layers[1].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+Math.PI);

                layers[3].pixiLayer.x = multiplier*1*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime));
                layers[3].pixiLayer.y = multiplier*1*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime));

                layers[4].pixiLayer.x = multiplier*0.4*Math.sin(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
                layers[4].pixiLayer.y = multiplier*0.2*Math.cos(-1*2*Math.PI*rotationSpeed*(aTime)+0.5*Math.PI);
            }
            
        }
        
    }

    reset() {
        
        let currentArray = this.item.layers;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentLayer = currentArray[i].pixiLayer;
            currentLayer.parent.removeChild(currentLayer);
        }

        this.item.layers = [];
        this.item.jumpLayers = [];
        this.item.projectileLayers = [];
    }

    setupGraphics(aPlayerId) {
        this.reset();
        let playerId = aPlayerId;
        if(playerId === "affe"){
            let legsLayer = new Website.game.gameplay.player.SwitchableGraphics();

            let characterName = "characters/affe";

            legsLayer.addGraphics("walk", Website.game.getAnimatedSprite(characterName, "walk"));
            legsLayer.addGraphics("jump", Website.game.getSprite(characterName, "jump"));
            legsLayer.addGraphics("stand", Website.game.getSprite(characterName, "layer-01"));

            this.addJumpLayer(legsLayer.item);

            let armLayer = new Website.game.gameplay.player.SwitchableGraphics();
            armLayer.addGraphics("loaded", Website.game.getAnimatedSprite(characterName, "layer-02"));
            armLayer.addGraphics("empty", Website.game.getSprite(characterName, "layer-02-open"));

            this.addProjectileLayer(armLayer.item);
            
            const layerTextures = Website.game.getTextures(characterName, "layer");

            this.addLayers(layerTextures);
        }
        else if(playerId === "svenne") {
            let characterName = "characters/svenne";

            let boardLayer = new Website.game.gameplay.player.SwitchableGraphics();

            boardLayer.addGraphics("walk", Website.game.getAnimatedSprite(characterName, "board"));
            boardLayer.addGraphics("jump", Website.game.getAnimatedSprite(characterName, "board-flip"));
            boardLayer.addGraphics("stand", Website.game.getSprite(characterName, "layer-01"));

            this.addJumpLayer(boardLayer.item);

            let legsLayer = new Website.game.gameplay.player.SwitchableGraphics();
            legsLayer.addGraphics("walk", Website.game.getAnimatedSprite(characterName, "layer-02"));
            legsLayer.addGraphics("jump", Website.game.getSprite(characterName, "jump"));
            legsLayer.addGraphics("stand", Website.game.getAnimatedSprite(characterName, "layer-02"));
            this.addJumpLayer(legsLayer.item);

            const layerTextures = Website.game.getTextures(characterName, "layer");
            this.addLayers(layerTextures);

            let armLayer = new Website.game.gameplay.player.SwitchableGraphics();
            let animationLayer = Website.game.getAnimatedSprite("objects/ball-bearings", "animation", 0.5);
            animationLayer.position.set(15, -34);
            armLayer.addGraphics("loaded", animationLayer);

            this.addProjectileLayer(armLayer.item);
        }
        else if(playerId === "saga") {
            let characterName = "characters/saga";

            let legsLayer = new Website.game.gameplay.player.SwitchableGraphics();
            legsLayer.addGraphics("walk", Website.game.getAnimatedSprite(characterName, "walk"));
            legsLayer.addGraphics("jump", Website.game.getSprite(characterName, "jump"));
            legsLayer.addGraphics("stand", Website.game.getSprite(characterName, "layer-01"));
            this.addJumpLayer(legsLayer.item);

            const backHairTextures = Website.game.getTextures(characterName, "layer-02");
            this.addLayers(backHairTextures);

            

            let armLayer = new Website.game.gameplay.player.SwitchableGraphics();
            armLayer.addGraphics("loaded", Website.game.getSprite(characterName, "layer-03"));
            armLayer.addGraphics("empty", Website.game.getSprite(characterName, "layer-03-open"));

            this.addProjectileLayer(armLayer.item);

            const layerTextures = Website.game.getTextures(characterName, "layer");
            this.addLayers(layerTextures);
        }
        else if(playerId === "ninni") {
            let characterName = "characters/ninni";

            let legsLayer = new Website.game.gameplay.player.SwitchableGraphics();
            legsLayer.addGraphics("walk", Website.game.getAnimatedSprite(characterName, "walk"));
            //legsLayer.addGraphics("jump", Website.game.getSprite(characterName, "jump"));
            legsLayer.addGraphics("stand", Website.game.getSprite(characterName, "layer-01"));
            this.addJumpLayer(legsLayer.item);

            let armLayer = new Website.game.gameplay.player.SwitchableGraphics();
            armLayer.addGraphics("loaded", Website.game.getSprite(characterName, "layer-02"));
            armLayer.addGraphics("empty", Website.game.getSprite(characterName, "layer-02-open"));

            this.addProjectileLayer(armLayer.item);

            const layerTextures = Website.game.getTextures(characterName, "layer");
            this.addLayers(layerTextures);
        }
        else {
            let characterName = "characters/theo";

            let legsLayer = new Website.game.gameplay.player.SwitchableGraphics();
            legsLayer.addGraphics("walk", Website.game.getAnimatedSprite(characterName, "walk"));
            legsLayer.addGraphics("jump", Website.game.getSprite(characterName, "jump"));
            legsLayer.addGraphics("stand", Website.game.getSprite(characterName, "layer-01"));
            this.addJumpLayer(legsLayer.item);

            let armLayer = new Website.game.gameplay.player.SwitchableGraphics();
            armLayer.addGraphics("loaded", Website.game.getSprite(characterName, "layer-02"));
            armLayer.addGraphics("empty", Website.game.getSprite(characterName, "layer-02-open"));

            this.addProjectileLayer(armLayer.item);

            const layerTextures = Website.game.getTextures(characterName, "layer");
            this.addLayers(layerTextures);
        }

        this.item.speechBubble.controller.setup(140, true);
        this.item.pixiLayer.addChild(this.item.speechBubble.pixiLayer);
    }
}